import * as React from 'react'
import styled from 'styled-components'
import * as Redux from 'react-redux'

import { t } from '@owl-nest/localize'
import { styles as S } from '@ulule/owl-kit-components/next'
import * as plume from '@ulule/owl-kit-components/next'
import * as api from '@owl-nest/api-client/latest'
import { useAuth } from '@owl-nest/redux-wrapper/hooks'

import { State as CommentState } from '../../../../../reducers/comments'
import { RootState } from '../../../../../reducers'

import { CommentForm, CommentFormValue } from './CommentForm'
import { CommentList } from './CommentList'
import { Project } from '../../../../models/project'

type CommentsProps = {
  rootList: CommentState['list']['root']
  onRootSubmit: (values: CommentFormValue) => Promise<void>
  onLoadMore: (next: string) => void
  autoFocus?: boolean
}

const Connect = React.lazy(async () => ({ default: (await import('../../../../components/Connect')).Connect }))

export function Comments({
  rootList,
  onRootSubmit,
  onLoadMore,
  autoFocus,
}: CommentsProps): React.ReactElement<CommentsProps> {
  const project = Redux.useSelector<RootState, Project>((state) => state.application.project.data)
  const auth = useAuth()

  return (
    <>
      <>
        {auth.type === 'loggedin' ? (
          <>
            {project.comments_allowed && (
              <RootCommentForm user={auth.user} onSubmit={onRootSubmit} autoFocus={autoFocus} />
            )}
          </>
        ) : (
          <React.Suspense fallback={<plume.Spinner />}>
            <ConnectWrapper>
              <S.heading.M>{t('Login to leave a comment')}</S.heading.M>
              <Connect extraFields={[]} />
            </ConnectWrapper>
          </React.Suspense>
        )}
      </>
      {rootList && <CommentList list={rootList} onLoadMore={onLoadMore} />}
    </>
  )
}

type RootCommentFormProps = {
  user: api.AuthenticatedUser
  onSubmit: (values: CommentFormValue) => Promise<void>
  autoFocus?: boolean
}

function RootCommentForm({
  user,
  onSubmit,
  autoFocus,
}: RootCommentFormProps): React.ReactElement<RootCommentFormProps> {
  return <CommentForm user={user} onSubmit={onSubmit} submitLabel={t('Send')} autoFocus={autoFocus} />
}

const ConnectWrapper = styled.div`
  max-width: 430px;
  margin: 0 auto 30px;

  ${S.heading.M} {
    text-align: center;
    margin-bottom: 30px;
  }
`
